module.exports = __webpack_public_path__ + "static/img/Serve18_2@2x.3004ed4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Serve18_2@2x.png
// module id = mIpT
// module chunks = 1